
export interface ScatterCoordinate
{
    Reel: number;
    Row: number;
}

export interface IFillingPotIncrements {
    //increment: number,
    BonusWin: boolean;
    ScatterCordinates: ScatterCoordinate[];
    winSymbols : string[][];
}

export const BonusWillUpdateFillingPotFeature = [
    "ExtendedSpinAndHold","SpinAndHold" , "MultiBonus"
]